var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmphasis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.8578 0.5 0.5 3.8578 0.5 8C0.5 12.1422 3.8578 15.5 8 15.5C12.1422 15.5 15.5 12.1422 15.5 8C15.5 3.8578 12.1422 0.5 8 0.5ZM10.9491 7.6664L9.5549 8.77897L10.0289 10.4988C10.0681 10.6419 10.0149 10.7946 9.89466 10.882C9.77439 10.9692 9.61279 10.9727 9.48875 10.891L7.99959 9.90857L6.51087 10.891C6.38686 10.9727 6.22522 10.9692 6.10473 10.882C5.98449 10.7946 5.93129 10.6419 5.97052 10.4988L6.44472 8.77897L5.05027 7.6664C4.93449 7.57379 4.88773 7.41881 4.93382 7.27751C4.97964 7.13624 5.10843 7.03815 5.25655 7.03156L7.03871 6.951L7.66599 5.28104C7.71843 5.14212 7.85146 5.04998 7.99959 5.04998C8.14842 5.04998 8.28119 5.14215 8.3334 5.28104L8.96094 6.951L10.7426 7.03156C10.891 7.03818 11.02 7.13624 11.0658 7.27751C11.1119 7.41881 11.0653 7.57379 10.9491 7.6664Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmphasis);
export default __webpack_public_path__ + "static/media/icon-emphasis.7d970111a15a95e77cdfc119bc8b8390.svg";
export { ForwardRef as ReactComponent };